export function downloadAppBannerReducer(state: boolean = false): boolean {
  return state;
}
